/*--グローバルナビを途中から固定--*/
$(function () {
});
$(window).on('load', function () {
	var offset = $('.topnavi').offset();

	$(window).scroll(function () {
		if ($(window).scrollTop() > offset.top) {
			$('.topnavi').addClass('fixed');
		} else {
			$('.topnavi').removeClass('fixed');
		}
	});
})
/*--スマートスクロール--*/
$(function () {
	$('a[href^="#"].pointLink').click(function () {
		var speed = 400;
		var href = jQuery(this).attr("href");
		var target = jQuery(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('body,html').animate({ scrollTop: position }, speed, 'swing');
		return false;
	});
});
/*--フローティングナビ--*/
$(function () {
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$('.float_bnr').fadeIn();
		} else {
			$('.float_bnr').fadeOut();
		}
	});
});

/*--ハンバーガーメニュー--*/
$(function () {
	$('#nav_toggle').click(function () {
		$(".topnavi").toggleClass('open');
		$(".topnavi ul").slideToggle(500);
	});
});

/* ----------------------------------------------------------
//PC/SPで使用する画像を切替える(画像のファイル名末尾を_pc/_spとする)
---------------------------------------------------------- */
$(function () {
	var $setElem = $(".change"), //画像をclassに
		pcName = '_pc', //画像のファイル名
		spName = '_sp', //画像のファイル名
		replaceWidth = 780; //分岐するサイズ

	$setElem.each(function () {
		var $this = $(this);
		function imgSize() {
			var windowWidth = parseInt($(window).width());
			if (windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(spName, pcName));
			} else if (windowWidth < replaceWidth) {
				$this.attr('src', $this.attr('src').replace(pcName, spName));
			}
		}
		$(window).resize(function () { imgSize(); });
		imgSize();
	});
});

/* ----------------------------------------------------------
//SP時のみtelリンクイキ
---------------------------------------------------------- */
if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
	$(function () {
		// $('.tel').each(function () {
		// 	var str = $(this).html();
		// 	if ($(this).children().is('img')) {
		// 		$(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
		// 	} else {
		// 		$(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
		// 	}
		// });
	});
}

/**
 * mv js
 */
$(function () {
	$('#js-slider').slick({
		fade: true,
		autoplay: true,
		//autoplaySpeed: 5000,
		//speed: 5000,
		dots: false,
		arrows: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		adaptiveHeight: false,
	});
	$('.js-roomslider').slick({
		fade: true,
		autoplay: true,
		dots: true,
		arrows: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		//adaptiveHeight: true,
	});
	$('.js-topslider').slick({
		//autoplay: true,
		dots: true,
		arrows: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		//adaptiveHeight: true,
	});

});
$(window).on('load', function () {
	$('.slick-slider').addClass('is-loaded');
})

/**
 * accordion
 */
$(function(){
	$('.js-accshow').click(function(){
		$(this).next().stop().slideToggle();
		return false;
	})
})